import React from "react";
import { Link } from "react-router-dom";
import { ENERGY_TIERS, SOFT_TIERS } from "@/lib/commissions";

function Row({ t, highlightKey }) {
  const active = t.key === highlightKey;
  return (
    <tr
      className={`border-b border-line last:border-0 ${active ? "bg-oxblood/5" : ""}`}
      data-testid={`comm-row-${t.key}`}
      data-active={active ? "1" : "0"}
    >
      <td className="p-3.5 h-serif text-base text-ink">
        {t.label}
        {active && <span className="ml-2 text-[10px] font-mono uppercase text-oxblood">● your rate</span>}
      </td>
      <td className="p-3.5 text-sub text-sm tabular">{t.trial}</td>
      <td className="p-3.5 text-right font-mono text-sm text-ink tabular">{t.min}</td>
      <td className="p-3.5 text-right font-mono text-sm text-oxblood tabular">{t.max}</td>
    </tr>
  );
}

/**
 * Compact commission schedule — meant for the gated dashboard.
 * `highlightKey` (optional) tints the matching row in oxblood so the buyer
 * can spot their applicable rate immediately.
 */
export default function CommissionTable({ highlightKey = null, testid = "commission-table" }) {
  return (
    <div className="border border-line bg-parchment" data-testid={testid}>
      <table className="w-full">
        <thead>
          <tr className="border-b border-line text-left font-mono text-[10px] text-sub uppercase tracking-wider bg-parchment2">
            <th className="p-3.5">Commodity</th>
            <th className="p-3.5">Trial volume</th>
            <th className="p-3.5 text-right">Min</th>
            <th className="p-3.5 text-right">Max</th>
          </tr>
        </thead>
        <tbody>
          <tr><td colSpan={4} className="px-3.5 py-2 overline bg-parchment2 border-b border-line">Energy</td></tr>
          {ENERGY_TIERS.map((t) => <Row key={t.key} t={t} highlightKey={highlightKey} />)}
          <tr><td colSpan={4} className="px-3.5 py-2 overline bg-parchment2 border-y border-line">Soft commodities</td></tr>
          {SOFT_TIERS.map((t) => <Row key={t.key} t={t} highlightKey={highlightKey} />)}
        </tbody>
      </table>
      <div className="px-3.5 py-3 text-[10px] font-mono text-sub uppercase tracking-wider border-t border-line">
        Indicative — final rate lodged in the IMFPA per deal · <Link to="/process" className="link text-ink">view full schedule</Link>
      </div>
    </div>
  );
}
